import { Component } from '@angular/core';
import { FileManagerComponent } from '../../../components/pages/file-manager/file-manager.component';

@Component({
  selector: 'app-shared-resources-file-manager',
  imports: [FileManagerComponent],
  templateUrl: './shared-resources-file-manager.component.html',
  styleUrl: './shared-resources-file-manager.component.scss'
})
export class SharedResourcesFileManagerComponent {
  initialPath: string = 'sharedResources';
}
